export default [
    {
        "from": 1,
        "to": 17.5,
        "DV": " ",
        "data": [],
        "pic": "0"
    },
    {
        "from": 17.0,
        "to": 19.9,
        "DV": "އަހަރެން ގުޑުވާލިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "هزتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ގުޑުވާލިއެވެ"
            }
        ]
    },
    {
        "from": 20,
        "to": 22.6,
        "DV": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "نسمات الليالي"
            },
            {
                "lang": "dv",
                "text": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ"
            },
        ]
    },
    {
        "from": 22.6,
        "to": 25.5,
        "DV": "ލޯމައްޗަށް އެވެރިވިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "فترآء ببالي "
            },
            {
                "lang": "dv",
                "text": "ލޯމައްޗަށް އެވެރިވިއެވެ"
            }
        ],
    },
    {
        "from": 25.5,
        "to": 29.1,
        "DV": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "طيف آلآم مرير"
            },
            {
                "lang": "dv",
                "text": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ"
            }
        ]
    },
    {
        "from": 29.1,
        "to": 31,
        "DV": "އަހަރެން ރޮއްވައިފިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "أبكتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ރޮއްވައިފިއެވެ"
            }
        ],
        "pic": "1"
    },
    {
        "from": 31,
        "to": 33.6,
        "DV": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "صرخات الأيامى"
            },
            {
                "lang": "dv",
                "text": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ"
            }
        ]
    },
    {
        "from": 33.6,
        "to": 36.7,
        "DV": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "وأنين تنامى"
            },
            {
                "lang": "dv",
                "text": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ"
            }
        ]
    },
    {
        "from": 36.7,
        "to": 40,
        "DV": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "حول قيد وأسير"
            },
            {
                "lang": "dv",
                "text": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ"
            }
        ]
    },
    {
        "from": 40,
        "to": 41.88,
        "DV": "އަހަރެން ފުނޑުކޮށްލައެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "تكويني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ފުނޑުކޮށްލައެވެ"
            }
        ],
        "pic": "2"
    },
    {
        "from": 41.88,
        "to": 45,
        "DV": "ދަރީން ގެއްލުނު މައިންބަފައިންގެ ގިސްލުމެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "شهقات الثكالى"
            },
            {
                "lang": "dv",
                "text": "ދަރީން ގެއްލުނު މައިންބަފައިންގެ ގިސްލުމެވެ"
            }
        ]
    },
    {
        "from": 45,
        "to": 48,
        "DV": "ފުލުފުލުން އަންނަ ޒަޚަމްތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "طعنات توالى"
            },
            {
                "lang": "dv",
                "text": "ފުލުފުލުން އަންނަ ޒަޚަމްތަކެވެ"
            }
        ]
    },
    {
        "from": 48,
        "to": 51,
        "DV": "ލޯބި ކުޑަކުދިންގެ ކަރުނަތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "دمعة الطفل الغرير"
            },
            {
                "lang": "dv",
                "text": "ލޯބި ކުޑަކުދިންގެ ކަރުނަތަކެވެ"
            }
        ]
    },
    {
        "from": 51,
        "to": 52.9,
        "DV": "އަހަންނަށް އެހީވެދޭށެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "مُديني"
            },
            {
                "lang": "dv",
                "text": "އަހަންނަށް އެހީވެދޭށެވެ"
            }
        ]
    },
    {
        "from": 52.9,
        "to": 56,
        "DV": "އޭފަހެ ވަޤުތުގެ ރިޔަލާއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "يا شراع الزمان"
            },
            {
                "lang": "dv",
                "text": "އޭފަހެ ވަޤުތުގެ ރިޔަލާއެވެ"
            }
        ]
    },
    {
        "from": 56,
        "to": 59,
        "DV": "އުއްމީދުގެ ބިންތަކަށެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "لربوع الاماني"
            },
            {
                "lang": "dv",
                "text": "އުއްމީދުގެ ބިންތަކަށެވެ"
            }
        ]
    },
    {
        "from": 59,
        "to": 62,
        "DV": "އުފަލުގެ އަލި ހިނދުކޮޅަކަށެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "لمدى زاه منير"
            },
            {
                "lang": "dv",
                "text": "އުފަލުގެ އަލި ހިނދުކޮޅަކަށެވެ"
            }
        ]
    },
    {
        "from": 62,
        "to": 64,
        "DV": "އަހަރެން ގުޑުވާލިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "هزتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ގުޑުވާލިއެވެ"
            }
        ]
    },
    {
        "from": 64,
        "to": 67,
        "DV": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "نسمات الليالي"
            },
            {
                "lang": "dv",
                "text": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ"
            }
        ],
        "pic":"3"
    },
    {
        "from": 67,
        "to": 70,
        "DV": "ލޯމައްޗަށް އެވެރިވިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "فترآء ببالي "
            },
            {
                "lang": "dv",
                "text": "ލޯމައްޗަށް އެވެރިވިއެވެ"
            }
        ]
    },
    {
        "from": 70,
        "to": 73.2,
        "DV": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "طيف آلآم مرير"
            },
            {
                "lang": "dv",
                "text": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ"
            },
        ]
    },
    {
        "from": 73.2,
        "to": 75,
        "DV": "އަހަރެން ރޮއްވައިފިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "أبكتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ރޮއްވައިފިއެވެ"
            }
        ]
    },
    {
        "from": 75,
        "to": 78,
        "DV": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "صرخات الأيامى"
            },
            {
                "lang": "dv",
                "text": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ"
            }
        ]
    },
    {
        "from": 78,
        "to": 81,
        "DV": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "وأنين تنامى"
            },
            {
                "lang": "dv",
                "text": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ"
            }
        ]
    },
    {
        "from": 81,
        "to": 84,
        "DV": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "حول قيد وأسير"
            },
            {
                "lang": "dv",
                "text": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ"
            }
        ]
    },
    {
        "from": 84,
        "to": 85.8,
        "DV": "އޭ ޤުދުސެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "يا قدسي"
            },
            {
                "lang": "dv",
                "text": "އޭ ޤުދުސެވެ"
            }
        ]
    },
    {
        "from": 85.8,
        "to": 89,
        "DV": "އޭ މިނަފުސުގެ ނޭވާތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "يا نفائح نفسي"
            },
            {
                "lang": "dv",
                "text": "އޭ މިނަފުސުގެ ނޭވާތަކެވެ"
            }
        ]
    },
    {
        "from": 89,
        "to": 92,
        "DV": "އަހަރެންގެ ރޭތައް ކެކުޅެނީ ތިބާއަށެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "فيك ليلي وهمسي"
            },
            {
                "lang": "dv",
                "text": "އަހަރެންގެ ރޭތައް ކެކުޅެނީ ތިބާއަށެވެ"
            }
        ]
    },
    {
        "from": 92,
        "to": 95,
        "DV": "ދުޢާ ތަކާއި ރައްކައުތެރިކަމަށް އެދެމުއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "ودعاء المستجير"
            },
            {
                "lang": "dv",
                "text": "ދުޢާ ތަކާއި ރައްކައުތެރިކަމަށް އެދެމުއެވެ"
            }
        ]
    },
    {
        "from": 95,
        "to": 97,
        "DV": "ކާކަށްބަ އެނގެނީ؟",
        "data": [
            {
                "lang": "ar",
                "text": "من يدري"
            },
            {
                "lang": "dv",
                "text": "ކާކަށްބަ އެނގެނީ؟"
            }
        ],
        "pic": "4"
    },
    {
        "from": 97,
        "to": 99.9,
        "DV": "މިމޭގަނޑުގެ ތެރޭ މިހިރަ އެނދުންތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "يا صبابة صدري"
            },
            {
                "lang": "dv",
                "text": "މިމޭގަނޑުގެ ތެރޭ މިހިރަ އެނދުންތަކެވެ"
            }
        ]
    },
    {
        "from": 99.9,
        "to": 102.5,
        "DV": "އަހަރެންގެ ފަޖުރުލީ ބިމާއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "أرض ميلاد فجرى"
            },
            {
                "lang": "dv",
                "text": "އަހަރެންގެ ފަޖުރުލީ ބިމާއެވެ"
            }
        ]
    },
    {
        "from": 102.5,
        "to": 106.03,
        "DV": "ޢުދުވާން ވެވުނު އެރެއަށް ފަހުގައެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "يعقب الليل المغير"
            },
            {
                "lang": "dv",
                "text": "ޢުދުވާން ވެވުނު އެރެއަށް ފަހުގައެވެ"
            }
        ]
    },
    {
        "from": 106.03,
        "to": 107.6,
        "DV": "އަހަރެން ގުޑުވާލިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "هزتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ގުޑުވާލިއެވެ"
            }
        ]
    },
    {
        "from": 107.6,
        "to": 110.8,
        "DV": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "نسمات الليالي"
            },
            {
                "lang": "dv",
                "text": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ"
            },
        ]
    },
    {
        "from": 110.8,
        "to": 113.4,
        "DV": "ލޯމައްޗަށް އެވެރިވިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "فترآء ببالي "
            },
            {
                "lang": "dv",
                "text": "ލޯމައްޗަށް އެވެރިވިއެވެ"
            },
        ]
    },
    {
        "from": 113.4,
        "to": 116.2,
        "DV": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "طيف آلآم مرير"
            },
            {
                "lang": "dv",
                "text": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ"
            }
        ]
    },
    {
        "from": 116.2,
        "to": 118.6,
        "DV": "އަހަރެން ރޮއްވައިފިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "أبكتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ރޮއްވައިފިއެވެ"
            }
        ]
    },
    {
        "from": 118.6,
        "to": 121.5,
        "DV": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "صرخات الأيامى"
            },
            {
                "lang": "dv",
                "text": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ"
            }
        ]
    },
    {
        "from": 121.5,
        "to": 124.6,
        "data": [
            {
                "lang": "ar",
                "text": "وأنين تنامى"
            },
            {
                "lang": "dv",
                "text": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ"
            }
        ],
        "DV": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ"
    },
    {
        "from": 124.6,
        "to": 128,
        "DV": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "حول قيد وأسير"
            },
            {
                "lang": "dv",
                "text": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ"
            }
        ]
    },
    {
        "from": 128,
        "to": 129.7,
        "DV": "އެކަމަނާ(މާތް ޤުދުސް)ގެ ލޮލެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "عيناها"
            },
            {
                "lang": "dv",
                "text": "އެކަމަނާ(މާތް ޤުދުސް)ގެ ލޮލެވެ"
            }
        ]
    },
    {
        "from": 129.7,
        "to": 132.7,
        "DV": "އޭގެ އޮހޮރުންތަކާއި ޝަކުވާތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "نزفها مشتكاها"
            },
            {
                "lang": "dv",
                "text": "އޭގެ އޮހޮރުންތަކާއި ޝަކުވާތަކެވެ"
            }
        ],
        "pic": "5"
    },
    {
        "from": 132.7,
        "to": 135.4,
        "DV": "ހިތާމަތަކާއި ރުއިންތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "حزنها وبكاها"
            },
            {
                "lang": "dv",
                "text": "ހިތާމަތަކާއި ރުއިންތަކެވެ"
            }
        ]
    },
    {
        "from": 135.4,
        "to": 138.4,
        "DV": "އެކަމަނާގެ މިސްކިތާއި މަގުތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "مسجداها والمسير"
            },
            {
                "lang": "dv",
                "text": "އެކަމަނާގެ މިސްކިތާއި މަގުތަކެވެ"
            }
        ]
    },
    {
        "from": 138.4,
        "to": 140.7,
        "DV": "އެދެވެރިން ސުވާލުކުރިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "سألاها"
            },
            {
                "lang": "dv",
                "text": "އެދެވެރިން ސުވާލުކުރިއެވެ"
            }
        ]
    },
    {
        "from": 140.7,
        "to": 144,
        "DV": "ދެމިހުރި އެކަމަނާގެ އުއްމީދުތަކަށެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "عن بقايا رؤاها"
            },
            {
                "lang": "dv",
                "text": "ދެމިހުރި އެކަމަނާގެ އުއްމީދުތަކަށެވެ"
            }
        ]
    },
    {
        "from": 144,
        "to": 147,
        "DV": "ކުރިމަގުވަނީ ކޮންތާކަށްތޯއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "حين يرنو مناها"
            },
            {
                "lang": "dv",
                "text": "ކުރިމަގުވަނީ ކޮންތާކަށްތޯއެވެ"
            }
        ]
    },
    {
        "from": 147,
        "to": 150,
        "DV": "ޖަވާބުދިނެވެ: ޤަދަރުގެވެރި އިލާހުފުށުގައޭ އެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "فأجابت بالقدير"
            },
            {
                "lang": "dv",
                "text": "ޖަވާބުދިނެވެ: ޤަދަރުގެވެރި އިލާހުފުށުގައޭ އެވެ"
            }
        ]
    },
    {
        "from": 150,
        "to": 151.7,
        "DV": "އަހަރެން ގުޑުވާލިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "هزتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ގުޑުވާލިއެވެ"
            }
        ],
        "pic":"6"
    },
    {
        "from": 151.7,
        "to": 154.6,
        "DV": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "نسمات الليالي"
            },
            {
                "lang": "dv",
                "text": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ"
            },
        ]
    },
    {
        "from": 154.6,
        "to": 157.5,
        "DV": "ލޯމައްޗަށް އެވެރިވިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "فترآء ببالي "
            },
            {
                "lang": "dv",
                "text": "ލޯމައްޗަށް އެވެރިވިއެވެ"
            },
        ]
    },
    {
        "from": 157.5,
        "to": 160.9,
        "DV": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "طيف آلآم مرير"
            },
            {
                "lang": "dv",
                "text": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ"
            }
        ]
    },
    {
        "from": 160.9,
        "to": 163,
        "DV": "އަހަރެން ރޮއްވައިފިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "أبكتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ރޮއްވައިފިއެވެ"
            }
        ]
    },
    {
        "from": 163,
        "to": 165.5,
        "DV": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "صرخات الأيامى"
            },
            {
                "lang": "dv",
                "text": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ"
            }
        ]
    },
    {
        "from": 165.5,
        "to": 168.4,
        "DV": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "وأنين تنامى"
            },
            {
                "lang": "dv",
                "text": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ"
            }
        ]
    },
    {
        "from": 168.4,
        "to": 171.7,
        "DV": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "حول قيد وأسير"
            },
            {
                "lang": "dv",
                "text": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ"
            }
        ]
    },
    {
        "from": 171.7,
        "to": 173.4,
        "DV": "މި ހިތު އަޑިންނެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "من قلبي"
            },
            {
                "lang": "dv",
                "text": "މި ހިތު އަޑިންނެވެ"
            }
        ],
        "pic":"a"
    },
    {
        "from": 173.4,
        "to": 176.5,
        "DV": "މަގޭ ހިތުގެ ލޯތްބާއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "يا حبيبة قلبي"
            },
            {
                "lang": "dv",
                "text": "މަގޭ ހިތުގެ ލޯތްބާއެވެ"
            }
        ]
    },
    {
        "from": 176.5,
        "to": 179.4,
        "DV": "އަހަރެންގެ ރައްބަށް ދުޢާގައެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "بتُ أدعو لربي"
            },
            {
                "lang": "dv",
                "text": "އަހަރެންގެ ރައްބަށް ދުޢާގައެވެ"
            }
        ],
    },
    {
        "from": 179.4,
        "to": 182.5,
        "DV": "ތަސައްލީ އަކާއި އެހީތެރިކަމަކަށެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "أن يواسي ويجير"
            },
            {
                "lang": "dv",
                "text": "ތަސައްލީ އަކާއި އެހީތެރިކަމަކަށެވެ"
            }
        ]
    },
    {
        "from": 182.5,
        "to": 184.5,
        "DV": "މި ރޫހުންނެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "من روحي"
            },
            {
                "lang": "dv",
                "text": "މި ރޫހުންނެވެ"
            }
        ]
    },
    {
        "from": 184.5,
        "to": 187.7,
        "DV": "އޭ މިރޫހުގެ އެކުވެރިޔާއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "يا رفيقة روحي"
            },
            {
                "lang": "dv",
                "text": "އޭ މިރޫހުގެ އެކުވެރިޔާއެވެ"
            }
        ]
    },
    {
        "from": 187.7,
        "to": 190.5,
        "DV": "މިއައީ ތިބާގެ ހިތާމަ ހުއްޓޭތޯއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "جئت كي لا تنوحي"
            },
            {
                "lang": "dv",
                "text": "މިއައީ ތިބާގެ ހިތާމަ ހުއްޓޭތޯއެވެ"
            }
        ],
        "pic": "7"
    },
    {
        "from": 190.5,
        "to": 194,
        "DV": "ކަމަނާތީ، މިރޫހުގެ އެތައް ބައެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "أنتِ من روحي الكثير"
            },
            {
                "lang": "dv",
                "text": "ކަމަނާތީ، މިރޫހުގެ އެތައް ބައެކެވެ"
            }
        ]
    },
    {
        "from": 194,
        "to": 195.6,
        "DV": "އަހަރެން ގުޑުވާލިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "هزتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ގުޑުވާލިއެވެ"
            }
        ],
        "pic": "8"
    },
    {
        "from": 195.6,
        "to": 198,
        "DV": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "نسمات الليالي"
            },
            {
                "lang": "dv",
                "text": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ"
            },
        ]
    },
    {
        "from": 198,
        "to": 201,
        "DV": "ލޯމައްޗަށް އެވެރިވިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "فترآء ببالي "
            },
            {
                "lang": "dv",
                "text": "ލޯމައްޗަށް އެވެރިވިއެވެ"
            }
        ]
    },
    {
        "from": 201,
        "to": 205,
        "DV": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "طيف آلآم مرير"
            },
            {
                "lang": "dv",
                "text": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ"
            }
        ]
    },
    {
        "from": 205,
        "to": 206,
        "DV": "އަހަރެން ރޮއްވައިފިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "أبكتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ރޮއްވައިފިއެވެ"
            }
        ],
    },
    {
        "from": 206,
        "to": 209,
        "DV": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "صرخات الأيامى"
            },
            {
                "lang": "dv",
                "text": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ"
            }
        ]
    },
    {
        "from": 209,
        "to": 212,
        "DV": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "وأنين تنامى"
            },
            {
                "lang": "dv",
                "text": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ"
            }
        ]
    },
    {
        "from": 212,
        "to": 216,
        "DV": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "حول قيد وأسير"
            },
            {
                "lang": "dv",
                "text": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ"
            }
        ],
        "pic": "10"
    },
    {
        "from": 216,
        "to": 217.4,
        "DV": "އަހަރެން ގުޑުވާލިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "هزتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ގުޑުވާލިއެވެ"
            }
        ]
    },
    {
        "from": 217.4,
        "to": 220,
        "DV": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "نسمات الليالي"
            },
            {
                "lang": "dv",
                "text": "ދަންވަރުގެ ވައިރޯޅިތަކާއެވެ"
            },

        ]
    },
    {
        "from": 220,
        "to": 223,
        "DV": "ލޯމައްޗަށް އެވެރިވިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "فترآء ببالي "
            },
            {
                "lang": "dv",
                "text": "ލޯމައްޗަށް އެވެރިވިއެވެ"
            }
        ],
        "pic": "9"
    },
    {
        "from": 223,
        "to": 226.5,
        "DV": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "طيف آلآم مرير"
            },
            {
                "lang": "dv",
                "text": "ހިތި ތަދުތަކުގެ ހިޔަންޏެކެވެ"
            }
        ]
    },
    {
        "from": 226.5,
        "to": 228.5,
        "DV": "އަހަރެން ރޮއްވައިފިއެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "أبكتني"
            },
            {
                "lang": "dv",
                "text": "އަހަރެން ރޮއްވައިފިއެވެ"
            }
        ]
    },
    {
        "from": 228.5,
        "to": 231,
        "DV": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "صرخات الأيامى"
            },
            {
                "lang": "dv",
                "text": "ހުވަފަތް އަނބީންގެ ހިތާމަތެކެވެ"
            }
        ]
    },
    {
        "from": 231,
        "to": 234,
        "DV": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "وأنين تنامى"
            },
            {
                "lang": "dv",
                "text": "އުތުރިއަރަމުންދާ ރުއިންތަކެވެ"
            }
        ]
    },
    {
        "from": 234,
        "to": 259,
        "DV": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ",
        "data": [
            {
                "lang": "ar",
                "text": "حول قيد وأسير"
            },
            {
                "lang": "dv",
                "text": "ހައްޔަރުވެ އަސީރުވި (ޤުދުސް) ލާވަށައެވެ"
            }
        ]
    }
];